var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz-view-wrapper"},[(!_vm.loading)?_c(_vm.currentSystem,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }